import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Switch, Route, Redirect, withRouter } from "react-router-dom";
import { ModalRoute } from 'react-router-modal';

import Navbar from "./Components/Navbar.jsx";
import NavbarSelector from './Components/NavbarSelector';

import StakeholderDashboard from "./Components/Pages/Stakeholder/StakeholderDashboard.jsx";
import SHBookings from "./Components/Pages/Stakeholder/Bookings/SHBookings_New.jsx";
import MediaOverview from "./Components/Pages/Stakeholder/Media/MediaOverview.jsx";
import SHTiers from "./Components/Pages/Stakeholder/Tiers/TiersOverview.jsx";
import VehicleOverview from "./Components/Pages/Stakeholder/Vehicle/VehicleOverview";
import LegacyVehicleOverview from "./Components/Pages/Stakeholder/Vehicle/VehicleOverview/index_DEPRECATED.jsx";
import UserOverview from "./Components/Pages/Stakeholder/User/UserOverview.jsx";
import UserAdministration from "./Components/Pages/Stakeholder/UserAdmin";
import SHReports from "./Components/Pages/Stakeholder/SHReports";
import BusinessRules from "./Components/Pages/Stakeholder/BusinessRules.jsx";

import EUBookings from "./Components/Pages/EndUser/EUBookings.jsx";
import EUMedia from "./Components/Pages/EndUser/EUMedia.jsx";
import EUHome from "./Components/Pages/EndUser/EUHome.jsx";
import EUOEM from "./Components/Pages/EndUser/EUOEM.jsx";
import EUVehicle from "./Components/Pages/EndUser/EUVehicle";

import Settings from "./Components/Pages/Settings"

import Login from "./Components/Pages/Login.jsx";
import ForgotPassword from "./Components/Pages/ForgotPassword.jsx";
import ContactUs from "./Components/Pages/ContactUs.jsx";
import Unsubscribe from "./Components/Pages/Unsubscribe.jsx";
import Invite from "./Components/Pages/Invite.jsx";
import Signup from "./Components/Pages/Signup.jsx";
import Survey from "./Components/Pages/Survey.jsx";
import RoleSelection from "./Components/Pages/RoleSelection.jsx";
import SurveySuccess from "./Components/Pages/Survey/SurveySuccess";
import PrivacyPolicy from "./Components/Pages/PrivacyPolicy.jsx";
import EULA from "./Components/Pages/EULA.jsx";
import Help from "./Components/Pages/Help.jsx";
import PageNotFound from "./Components/Pages/PageNotFound.jsx";
import { LoadingIcon } from "./Components/Common/Loading_Icon";

import { checkAuthenticated, setUserSession } from "./Actions/userSessionActions";
import { setLogos } from "./Actions/settingsActions";

import {constants} from "./Helpers/Constants";
import ResetPassword from './Components/Pages/ResetPassword.jsx';
import MobileValidation from './Components/Pages/MobileValidation.jsx';
import IDVerification from './Components/Pages/IDVerification.jsx';
import RegistrationSuccess from './Components/Pages/RegistrationSuccess.jsx';
import CRPage from './Components/Pages/ConditionReportsTest/CRPage.jsx';
import ExpensesOverview from "./Components/Pages/Stakeholder/Expenses/ExpensesOverview.jsx";
import GeolocationPage from './Components/Pages/Stakeholder/Geolocation';
import OrderStatusPage from './Components/Pages/Stakeholder/OrderStatus/index.jsx';

import 'react-loading-skeleton/dist/skeleton.css'
import ReactTooltip from 'react-tooltip';


class DVMSRouter extends React.Component {
    constructor(props) {
        super(props);

        this.props.dispatch(checkAuthenticated())
    }
    
    componentDidMount() {
        if (this.props.sessionActive === "true") {
            this.props.dispatch(setUserSession({
                user_id: this.props.userId,
                email: this.props.email,
                full_name: this.props.fullName,
                user_type: this.props.userType,
                username: this.props.username,
                current_oem_name: this.props.sessionOemName,
                current_oem_id: this.props.sessionOemId
            }))
        } else if (this.props.sessionActive === "false" && ! this.props.userSession.logged_in && this.props.location.pathname !== "/login") {
            this.props.dispatch({type: "SET_PRE_REDIRECT_URL", payload: this.props.location.pathname})
        }
        this.props.dispatch(setLogos(this.props.loginLogo, this.props.logo, this.props.navLogo, this.props.serverEmailName))
    }

    componentDidUpdate() {
        ReactTooltip.rebuild();
    }

    render() {
        if (this.props.userSession.logged_in || this.props.sessionActive === "true") {

            if(this.props.userSession.user.eula_accepted == false) {
                if (this.props.userSession.oem_loaded) {
                    return(
                        <Switch>
                            <Route path={"/eula"} component={EULA} />
                            <Redirect to={"/eula"} component={EULA} />
                        </Switch>
                    )
                }
                else {
                    return(
                        <LoadingIcon />
                    )
                }
            }
            else if(this.props.userSession.user.pending_survey == true) {
                return(
                    <Switch>
                        <Route path={"/roleselection"} component={RoleSelection} />
                        <Route path={"/survey"} component={Survey} />
                        <Route path={"/surveysuccess"} component={SurveySuccess} />
                        <Route path={"/help"} navBar={Navbar} component={Help} />
                        <Route path={"/privacy"} navBar={Navbar} component={PrivacyPolicy} />
                        <Route path={"/contactus"} navBar={Navbar} component={ContactUs} />
                        <Redirect from={"/unsubscribe"} to={"/settings/notifications"} />
                        <Route path={"/idverification"} navbar={Navbar} component={IDVerification} />
                        <Route path={"/mobilevalidation"} navbar={Navbar} component={MobileValidation} />
                        <Route path={"/registrationsuccess"} component={RegistrationSuccess} />
                        <Redirect to={"/survey"} component={Survey} />
                    </Switch>
                )
            }

            else if (this.props.userSession.user.user_type === constants.user_type.user || parseInt(this.props.sessionType) === constants.user_type.user) {
                //End User Routes
                if (this.props.userSession.oem_loaded) {
                    if(this.props.userSession.user.user_role !== null) {
                        return(
                            <>
                                {/* <NavbarSelector history={this.props.history} match={this.props.match} location={this.props.location} /> */}
                                <Switch>
                                    <Route path={"/home"} navBar={Navbar} component={EUHome} />
                                    <Route path={"/vehicles/:stakeholder/:division"} navBar={Navbar} component={EUOEM} />
                                    <Route path={"/bookings/:tab/:book_id"} navBar={Navbar} component={EUBookings} />
                                    <Route path={"/bookings/:tab"} navBar={Navbar} component={EUBookings} />
                                    <Redirect from={"/bookings"} to={"/bookings/current"} />
                                    <Route path={"/eu-media"} navBar={Navbar} component={EUMedia} />
                                    <Route path={"/vehicle/:v_id"} navBar={Navbar} component={EUVehicle} />
                                    <Route path={"/login"} component={Login}/>
                                    <Route path={"/privacy"} navBar={Navbar} component={PrivacyPolicy} />
                                    <Route path={"/eula"} navBar={Navbar} component={EULA} />
                                    <Route path={"/help"} navBar={Navbar} component={Help} />
                                    <Route path={"/contactus"} navBar={Navbar} component={ContactUs} />
                                    <Route path={"/survey"} component={Survey} />
                                    <Route path={"/settings/:tab"} component={Settings} />
                                    <Redirect from={"/settings"} to={"/settings/user_info"} />
                                    <Route path={"/roleselection"} component={RoleSelection} />
                                    {/* <Route path={"/idverification"} navbar={Navbar} component={IDVerification} /> */}
                                    <Route path={"/mobilevalidation"} navbar={Navbar} component={MobileValidation} />
                                    <Redirect from={"/unsubscribe"} to={"/settings/notifications"} />
                                    <Redirect from={"/"} to={"/home"} />
                                    <Route component={PageNotFound} />
                                </Switch>
                            </>
                        )
                    } else {
                        return(
                            <>
                                {/* <NavbarSelector history={this.props.history} match={this.props.match} location={this.props.location} /> */}
                                <Switch>
                                    <Route path={"/home"} navBar={Navbar} component={EUHome} />
                                    <Route path={"/login"} component={Login}/>
                                    <Route path={"/privacy"} navBar={Navbar} component={PrivacyPolicy} />
                                    <Route path={"/eula"} navBar={Navbar} component={EULA} />
                                    <Route path={"/help"} navBar={Navbar} component={Help} />
                                    <Route path={"/contactus"} navBar={Navbar} component={ContactUs} />
                                    <Route path={"/survey"} component={Survey} />
                                    <Route path={"/roleselection"} component={RoleSelection} />
                                    {/* <Route path={"/surveysuccess"} component={SurveySuccess} /> */}
                                    {/* <Route path={"/idverification"} navbar={Navbar} component={IDVerification} /> */}
                                    <Route path={"/mobilevalidation"} navbar={Navbar} component={MobileValidation} />
                                    <Route path={"/registrationsuccess"} component={RegistrationSuccess} />
                                    <Route path={"/settings/:tab"} component={Settings} />
                                    <Redirect from={"/settings"} to={"/settings/profile"} />
                                    <Redirect from={"/unsubscribe"} to={"/settings/notifications"} />
                                    <Redirect from={"/"} to={"/home"} />
                                    <Route component={PageNotFound} />
                                </Switch>
                            </>
                        )
                    }
                } else {
                    return(
                        <LoadingIcon />
                    )
                }
            } else {
                // SH/VMH Routes
                if (this.props.userSession.oem_loaded) {
                    return (
                        <>
                            {/* <NavbarSelector history={this.props.history} match={this.props.match} location={this.props.location} /> */}
                            <Switch>
                                <Route path={"/home"} navBar={Navbar} component={StakeholderDashboard} />
                                <Route exact path={"/bookings/info/:book_id"} navBar={Navbar} component={SHBookings} />
                                {this.props.userSession.user.has_booking_access ? <Route exact path={"/bookings/new/:v_id"} navBar={Navbar} component={SHBookings} /> : null}
                                {this.props.userSession.user.has_booking_access ? <Route exact path={"/bookings/new"} navBar={Navbar} component={SHBookings} /> : null}
                                <Route path={"/bookings"} navBar={Navbar} component={SHBookings} />
                                <Route path={"/login"} component={Login} />
                                <Route path={"/privacy"} navBar={Navbar} component={PrivacyPolicy} />
                                <Route path={"/eula"} navBar={Navbar} component={EULA} />
                                <Route path={"/help"} navBar={Navbar} component={Help} />
                                <Route path={"/mediaoverview"} navBar={Navbar} component={MediaOverview} />
                                <Route path={"/expensesoverview"} navBar={Navbar} component={ExpensesOverview} />
                                <Route path={"/geolocation"} navBar={Navbar} component={GeolocationPage} />
                                <Route path={"/orders"} navBar={Navbar} component={OrderStatusPage} />
                                <Route path={"/mediaoverview/:tab"} navBar={Navbar} component={MediaOverview} />
                                <Route path={"/tiers"} navBar={Navbar} component={SHTiers} />
                                <Route path={"/tiers/:tab"} navBar={Navbar} component={SHTiers} />
                                <Route path={"/vehicleoverview"} navBar={Navbar} component={LegacyVehicleOverview} />
                                <Route path={"/useroverview"} navBar={Navbar} component={UserOverview} />
                                <Route path={"/eu-vehicle/:v_id"} navBar={Navbar} component={EUVehicle} />
                                <Route path={"/privacy"} navBar={Navbar} component={PrivacyPolicy} />
                                <Route path={"/contactus"} navBar={Navbar} component={ContactUs} />
                                <Route path={"/administration"} navBar={Navbar} component={UserAdministration} />
                                <Route path={"/businessrules"} navBar={Navbar} component={BusinessRules} />
                                <Route path={"/mobilevalidation"} navbar={Navbar} component={MobileValidation} />
                                <Route path={"/conditionreports"} component={CRPage} />
                                <Route path={"/surveysuccess"} component={SurveySuccess} />
                                <Route path={"/settings/:tab"} component={Settings} />
                                <Redirect path={"/settings"} to={"/settings/user_info"} />
                                <Route path={"/shreports"} component={SHReports} />
                                <Redirect from={"/unsubscribe"} to={"/settings/notifications"} />
                                <Redirect from={"/"} to={"/home"} />
                                <Route component={PageNotFound} />
                            </Switch>
                        </>
                    )
                } else {
                    return(
                        <LoadingIcon />
                    )
                }
            }
        } else {
            //Not logged in routings
            return(
                <Switch>
                    <Route path={"/login"} component={Login} />
                    <Route path={"/forgotpassword"} component={ForgotPassword} />
                    <Route path={"/resetpassword/:password_link"} component={ResetPassword} />
                    <Route path={"/invite/:invite_id"} component={Invite} />
                    <Route path={"/signup/:invite_id"} component={Signup} />
                    <Route path={"/help"} navBar={Navbar} component={Help} />
                    <Route path={"/eula"} component={EULA} />
                    <Route path={"/privacy"} navBar={Navbar} component={PrivacyPolicy} />
                    <Route path={"/contactus"} navBar={Navbar} component={ContactUs} />
                    <Route path={"/unsubscribe/:unique_id"} navBar={Navbar} component={Unsubscribe} />
                    <Redirect to={"/login"} component={Login} />
                </Switch>
            )
        }
    }
}

const mapStateToProps = store => ({
    data: store.data,
    userSession: store.userSession,
    settings: store.settings
})

export default withRouter(connect(mapStateToProps)(DVMSRouter));